function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var InputWrapper = function (_React$Component) {
  _inherits(InputWrapper, _React$Component);

  function InputWrapper() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (event) {
      _this.props.onChange(_this.props.input, event.target.value);

      if (_this.props.xtraOnChange) _this.props.xtraOnChange();
    }, _this.onBlur = function (e) {
      if (_this.props.onBlur) _this.handleChange(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputWrapper.prototype.render = function render() {
    var errors = this.props.input.validations.errors.map(function (e) {
      return e;
    });
    var inputClass = classNames(this.props.className, {
      'editing': this.props.editing && !this.props.disabled,
      'error': this.props.input.validations.errors.length > 0 && !this.props.disabled
    });

    return React.createElement(
      'div',
      null,
      React.createElement('input', { type: this.props.type || "text",
        id: this.props.id,
        placeholder: this.props.placeholder,
        value: this.props.input.validations.val,
        onBlur: this.onBlur,
        onKeyUp: this.props.onKeyDown && this.props.onKeyDown,
        onChange: this.handleChange,
        tabIndex: this.props.tabOrder,
        className: inputClass,
        maxLength: this.props.maxLength && this.props.maxLength,
        autoFocus: this.props.autoFocus,
        disabled: this.props.disabled,
        autoComplete: this.props.autoComplete,
        ref: this.props.inputRef
      }),
      errors.length > 0 && React.createElement(
        'div',
        { className: 'error' },
        React.createElement(
          'ul',
          null,
          errors.map(function (e, i) {
            return e.message !== '' && React.createElement(
              'li',
              { key: i, className: 'error' },
              e.message
            );
          })
        )
      )
    );
  };

  return InputWrapper;
}(React.Component);

export { InputWrapper as default };


InputWrapper.PropTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  valid: PropTypes.func.isRequired,
  validations: PropTypes.func,
  tabOrder: PropTypes.string,
  editing: PropTypes.bool,
  defaultValue: PropTypes.string,
  id: PropTypes.string,
  autoComplete: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/wrappers/InputWrapper.js
// module id = 227
// module chunks = 4